import { useState } from 'preact/hooks';
import { auth, lastLogin, login, setup, shopName } from '../lib/khata.js';
import { ApiError, OfflineError } from '../lib/api.js';
import { t, toLatinDigits, translateError } from '../lib/i18n.js';
import { Field, TextInput } from '../components/index.js';
import { LangSwitch } from '../components/LangSwitch.js';

export function Login() {
  const isSetup = auth.value === 'setup';
  const [id, setId] = useState(isSetup ? '' : lastLogin());
  const [pin, setPin] = useState('');
  const [name, setName] = useState('');
  const [shop, setShop] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const ready = pin.length >= 4 && id.trim() !== '' && (!isSetup || name.trim() !== '');

  const submit = async (e: Event) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      if (isSetup) await setup({ login: id, name, pin, shopName: shop });
      else await login(id, pin);
    } catch (err) {
      if (err instanceof ApiError) setError(translateError(err.body));
      else if (err instanceof OfflineError) setError(t('form_offline'));
      else setError(t('login_wrong'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="login">
      <form class="login-box" onSubmit={submit}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 12,
          }}
        >
          <div class="nav-brand" style={{ marginBottom: 8 }}>
            {shopName.value || t('appName')}
            <br />
            <em>{isSetup ? t('login_firstTime') : t('login_khata')}</em>
          </div>
          <LangSwitch compact />
        </div>
        {isSetup && (
          <>
            <p class="small muted">{t('login_intro')}</p>
            <Field label={t('login_shopName')}>
              <TextInput
                value={shop}
                onInput={setShop}
                placeholder={t('login_shopPlaceholder')}
                autoFocus
              />
            </Field>
            <Field label={t('login_yourName')}>
              <TextInput value={name} onInput={setName} data-testid="login-name" />
            </Field>
          </>
        )}
        <Field label={t('login_id')}>
          <TextInput
            value={id}
            onInput={setId}
            autoCapitalize="none"
            autoComplete="username"
            inputMode="email"
            autoFocus={!isSetup && id === ''}
            data-testid="login-id"
          />
        </Field>
        <Field label={isSetup ? t('login_choosePin') : t('login_pin')}>
          <TextInput
            class="input pin"
            value={pin}
            onInput={(v) => setPin(toLatinDigits(v).replace(/\D/g, '').slice(0, 8))}
            type="password"
            inputMode="numeric"
            autoComplete="current-password"
            autoFocus={!isSetup && id !== ''}
          />
        </Field>
        {error && <div class="form-error">{error}</div>}
        <button type="submit" class="btn btn-primary btn-block" disabled={busy || !ready}>
          {isSetup ? t('login_create') : t('login_open')}
        </button>
      </form>
    </div>
  );
}
